import { PageBuilderElements } from '@chipinside/pagebuilder'
import { Stack } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { useFarmSlug } from '#/store/ducks/farm'
import { getLink } from '#/utils/getLink'

interface PageBuilderAnchorProps {
  id: string
  blank: boolean
  data: any
  identifier: string
  elements: any[]
}

const identifiers = ({ data, farmSlug, identifier }) => {
  switch (identifier) {
    case 'access-batch-monitoring':
      return getLink({
        id: 'farm-batch-monitoring',
        params: { batch: data?.batch, farm: farmSlug },
      })
    case 'access-farm-monitoring-ccom':
      return getLink({ id: 'farm-monitoring-c-com', params: { farm: farmSlug ?? data?.farm } })
    default:
      return getLink({ id: identifier, params: { farm: farmSlug ?? data?.farm, ...data } })
  }
}

export const PageBuilderAnchor = ({
  blank,
  data,
  elements,
  id,
  identifier,
  ...rest
}: PageBuilderAnchorProps) => {
  const farmSlug = useFarmSlug()

  const to = identifiers({ data, farmSlug, identifier })

  return (
    <Stack
      key={id}
      {...(to ? { component: RouterLink, target: blank ? '_blank' : undefined, to } : {})}
    >
      <PageBuilderElements elements={elements} {...rest} />
    </Stack>
  )
}
